import React, { useState } from "react";
import gettext from "../shared/utils/gettext";
import { PermissionObject } from "./utils";
import cropr from "../shared/utils/cropr";
import FileUploadModal from "./FileUploadModal";

type AvatarProps = {
  avatarUrl: string; //TODO remove
  avatarId: number;
  permission: PermissionObject | "all";
  avatarType: "farm" | "user";
  avatarStyleClasses?: string;
  allowDeleteAvatar?: boolean;
  onChange: (obj: any | undefined) => void;
};
const Avatar = ({
  avatarUrl, //TODO remove
  avatarId,
  permission,
  avatarType,
  avatarStyleClasses = "w-120px",
  allowDeleteAvatar = true,
  onChange = () => {},
}: AvatarProps) => {
  const permissionOK = Boolean(
    (avatarType === "user" || cropr.features.photo) &&
      (permission === "all" || (permission.create && permission.update))
  );
  const [showModal, setShowModal] = useState(false);
  const [showDeleteBtn, setShowDeleteBtn] = useState(false);
  const [selectedAvatarUrl, setSelectedAvatarUrl] = useState<string>((): string =>
    !avatarId ? avatarUrl : ""
  ); //TODO remove
  const [selectedAvatarId, setSelectedAvatarId] = useState<number>((): number => avatarId);
  const handleChange = (key: string) => {
    const selectedObject = cropr.images.models.find((o) => key === o.get("key"));
    setSelectedAvatarUrl("");
    setSelectedAvatarId(selectedObject?.get("id"));
    setShowModal(false);
    onChange(selectedObject);
  };
  const attachmentIdToThumbUrl = (id: number): string => {
    const selectedObject = id && cropr.images.models.find((o) => id === o.get("id"));
    if (!selectedObject)
      return (
        "/cropr/settings/avatar/get_text_avatar.svg?name=" +
        (avatarType === "farm" ? cropr.farm.get("name") : cropr.user.name)
      );
    return cropr.getImageUrl(selectedObject.get("key"), { resize: true, width: 120, height: 120 });
  };
  const handleSaveButton = (avatarKeys: string[]) => avatarKeys[0] && handleChange(avatarKeys[0]);
  return (
    <>
      <div
        className="avatar-img d-inline-block position-relative"
        onMouseEnter={() =>
          setShowDeleteBtn(
            permissionOK &&
              Boolean(
                selectedAvatarId ||
                  (selectedAvatarUrl && !selectedAvatarUrl.includes("get_text_avatar"))
              )
          )
        }
        onMouseLeave={() => setShowDeleteBtn(false)}
        style={permissionOK ? { cursor: "pointer" } : {}}
      >
        <img
          src={
            selectedAvatarId === undefined || selectedAvatarId > 0
              ? attachmentIdToThumbUrl(selectedAvatarId)
              : selectedAvatarUrl
          }
          className={avatarStyleClasses}
          onClick={() => setShowModal(permissionOK)}
          title={(permissionOK && gettext("Click to change avatar")) || ""}
          alt="..."
        />
        {allowDeleteAvatar && (
          <button
            type="button"
            className={
              "btn text-yellow position-absolute " + (showDeleteBtn ? "d-inline-block" : "d-none")
            }
            style={{ right: "0px", padding: "0.2rem 0.2rem" }}
            title={gettext("Delete")}
            onClick={() => handleChange("")}
          >
            <i className="far fa-trash-alt" />
          </button>
        )}
      </div>
      <FileUploadModal
        attachments={cropr.images.models}
        show={showModal}
        handleClose={() => setShowModal(false)}
        onChange={handleSaveButton}
        onlyImages={true}
        storageType={avatarType}
        singleSelect={true}
      />
    </>
  );
};

export default Avatar;
